/**
 * Returns the requested product attribute if available
 * 
 * @param {Object} product - The source product object
 * @param {string} attribute - The requested product attribute
 * @returns {string} The attribute value
 */
const getProductAttribute = function getProductAttribute(product, attribute) {
  let foundAttr;

  if (!product.attributeGroups) {
    return foundAttr;
  }

  const attributeGroupKeys = Object.keys(product.attributeGroups);

  for (let i = 0; i < attributeGroupKeys.length; i++) {
    if (product.attributeGroups[attributeGroupKeys[i]][attribute]) {
      foundAttr = product.attributeGroups[attributeGroupKeys[i]][attribute];
      break;
    }
  }

  return foundAttr && foundAttr.value && foundAttr.value[0];
};

export default getProductAttribute;
